import { motion } from "framer-motion";
import heroImg from "@/assets/hero-vr.webp";

const HeroSection = () => {
  const scrollToRent = () =>
    document.getElementById("rent")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={heroImg}
          alt="VR rental in Pune and Mumbai — rent Meta Quest 3 and Oculus headset near you"
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div
          className="absolute inset-0 z-[2]"
          style={{
            background: "hsl(var(--hero-scrim) / var(--hero-scrim-opacity))",
          }}
        />
        <div
          className="absolute inset-0 z-[2]"
          style={{
            background: "var(--hero-vignette)",
          }}
        />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-narrative mx-auto px-6 text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="font-body text-sm uppercase tracking-[0.3em] text-secondary mb-6"
        >
          Meta Quest 3 Rentals
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="font-heading text-5xl md:text-7xl lg:text-8xl font-bold leading-[0.95] tracking-tight text-foreground mb-6"
        >
          VR Rental
          <br />
          <span className="text-gradient">In Pune & Mumbai</span>
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.15 }}
          className="font-body text-lg md:text-xl max-w-2xl mx-auto mb-10"
        >
          <span className="block leading-relaxed">
            Rent Meta Quest 3 & Oculus Quest VR headsets in Pune & Mumbai.
          </span>
          <span className="block leading-relaxed mt-2">
            Bring your ideas to life with immersive VR for client demos,
            exhibitions, corporate events and interactive experiences.
          </span>
          <span className="block text-xs md:text-sm text-muted-foreground/80 mt-3">
            Meta Quest 2 • Quest 3 • Quest 3S&nbsp; | &nbsp;Flexible Rental Plans&nbsp; | &nbsp; Cash On Delivery
          </span>
        </motion.p>
        <motion.button
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.4, delay: 0.3 }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.97 }}
          onClick={scrollToRent}
          className="font-heading text-base font-semibold px-10 py-4 rounded-full bg-primary text-primary-foreground glow-magenta transition-all"
        >
          Choose Your Adventure
        </motion.button>
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2"
      >
        <motion.div
          animate={{ y: [0, 8, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
          className="w-5 h-8 border-2 border-muted-foreground/40 rounded-full flex justify-center pt-1.5"
        >
          <div className="w-1 h-2 bg-secondary rounded-full" />
        </motion.div>
      </motion.div>
    </section>
  );
};

export default HeroSection;
